<template>
	<v-row no-gutters justify-md="end" justify="center">
		<v-col class="btn__show-proposals d-flex justify-center justify-sm-end pb-sm-2 pb-md-0">
			<v-tooltip aria-label="Минимальная цена" position="left" open-delay="5000">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="outlined"
            size="small"
            color="blue"
            elevation="2"
            :block = "xs"
            v-on:click="showOffersByCompany()"
          >
            <span v-html="btn_text">
            </span>
            <v-icon
              class="pl-2 ml-0 mx-sm-0"
              right
              >
              {{ IconArrowRightBoldOutline }}
            </v-icon>
          </v-btn>
        </template>
        <span>От {{ parseInt(item.price ) }} рублей</span>
			</v-tooltip>
		</v-col>
	</v-row>
</template>
<script>
import { mapState } from "vuex";

import { mdiArrowRightBoldOutline } from '@mdi/js';
import { railsData } from "../../init_data/rails_data.js";

export default {
  name: "ShowFeeProposals",
  data() {
    return {
       IconArrowRightBoldOutline: mdiArrowRightBoldOutline,
       btn_text: 'Показать все предложения'
    };
  },
  props: ["item"],
  computed: {
    ...mapState({
        count_companies: (state) => state.companyM.selected_companies.length,
    }),
  },
  beforeMount() {
    if (railsData.is_mass) {
      this.btn_text = '<noindex>Все цены</noindex>'
    }
  },
  methods: {
    showOffersByCompany() {
      const selected_cities = this.$store.state.citiesM.selected_cities;
      let filters = JSON.stringify({...this.$store.getters.current_calculator_params, selected_cities });
      let current_company = this.item.company.id;

      let params = {
        filters,
        current_company
      }
      let url = "/company/" + this.item.company.slug;
      let submit_params = {
        target_blank: true,
        url,
        params
      }
			this.$store.dispatch("submitForm", submit_params);
    }
  },
};
</script>

<script setup>

import { useDisplay } from 'vuetify';
const { xs }= useDisplay();

</script>
